import Icon from '@mui/material/Icon'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import React from 'react'
import { Ballad } from '@digimap/types'

interface BalladListProps {
  ballads: Ballad[]
  onBalladClick: (ballad: Ballad) => void
  onBalladMouseEnter: (ballad: Ballad) => void
  onBalladMouseLeave: (ballad: Ballad) => void
}

function BalladList(props: BalladListProps) {
  function renderListItem(item: Ballad) {
    const icon = item.type === 'hike' ? 'directions_walk' : 'directions_bike'

    return (
      <ListItem
        key={item._id}
        divider
        button
        onClick={() => {
          props.onBalladClick(item)
        }}
        onMouseEnter={() => {
          props.onBalladMouseEnter(item)
        }}
        onMouseLeave={(e) => {
          props.onBalladMouseLeave(item)
        }}
      >
        <ListItemIcon>
          <Icon>{icon}</Icon>
        </ListItemIcon>
        <ListItemText primary={item.name} secondary={item.slug} />
      </ListItem>
    )
  }

  return <List>{props.ballads.map(renderListItem)}</List>
}

export default BalladList
